export default __webpack_public_path__ + "static/media/help-20x20_noFill.8b54809b.svg";